<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="800"
    content-class="pb-confirm-dialog"
    @click:outside="close"
  >
    <v-card class="pb-confirm-card">
      <v-toolbar color="primary" class="white--text" flat height="48">
        <v-toolbar-title class="font-weight-bold text-subtitle-1">
          {{ $t("memberDataSection.processingBatchConfirm.confirmDialogTitle") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon class="white--text" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pb-confirm-dialog__body pa-0">
        <section class="pb-confirm-section px-6 pt-5 pb-4">
          <div class="pb-confirm-content">
            <div class="pb-confirm-section__header d-flex justify-space-between align-center">
              <h3 class="pb-confirm-section__title mb-0">
                {{ $t("memberDataSection.processingBatchConfirm.detailConfirmation") }}
              </h3>
              <v-btn
                fab
                x-small
                depressed
                color="primary"
                class="pb-confirm-section__edit-btn white--text"
                @click="onEdit"
              >
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </div>

            <div
              v-for="(row, rowIndex) in fieldRows"
              :key="`pb-confirm-row-${rowIndex}`"
              class="pb-confirm-grid-row"
            >
              <div
                v-for="field in row"
                :key="field.key"
                class="pb-confirm-grid-cell"
              >
                <div class="pb-confirm-field-label">{{ field.label }}</div>
                <div class="pb-confirm-field-value">{{ field.value }}</div>
              </div>
            </div>

            <v-btn
              outlined
              color="primary"
              height="36"
              class="pb-confirm-quality-btn text-uppercase px-5"
              @click="$emit('quality-grade')"
            >
              <v-icon left small>mdi-seal</v-icon>
              {{ $t("memberDataSection.greenCoffee.createQualityGrade") }}
            </v-btn>
          </div>
        </section>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="px-6 py-4 pb-confirm-footer">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="primary"
          height="36"
          class="text-uppercase px-5 mr-3"
          :disabled="confirming"
          @click="close"
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          height="36"
          depressed
          class="text-uppercase white--text px-5"
          :loading="confirming"
          :disabled="confirming"
          @click="$emit('confirm')"
        >
          {{ $t("memberDataSection.processingBatchConfirm.confirmBtn") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProcessingBatchConfirmDialog",
  props: {
    value: { type: Boolean, default: false },
    fieldRows: { type: Array, default: () => [] },
    confirming: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: this.value,
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
    },
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit("close");
    },
    onEdit() {
      this.visible = false;
      this.$emit("edit");
    },
  },
};
</script>

<style lang="scss" scoped>
.pb-confirm-card {
  border-radius: 4px;
  overflow: hidden;
  font-family: "Poppins", sans-serif;
  background: #ffffff;
}

.pb-confirm-dialog__body {
  max-height: min(500px, calc(90vh - 120px));
  overflow-y: scroll;
  background: #ffffff;
}

.pb-confirm-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  padding: 0;
  width: 100%;
}

.pb-confirm-section__header {
  width: 100%;
}

.pb-confirm-section__title {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 700;
  font-size: 16px;
  line-height: 1.35;
}

.pb-confirm-section__edit-btn {
  box-shadow: none;
}

.pb-confirm-grid-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 20px;
  width: 100%;
}

.pb-confirm-grid-cell {
  min-width: 0;
}

.pb-confirm-field-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  line-height: 1.35;
  margin-bottom: 2px;
}

.pb-confirm-field-value {
  font-size: 16px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.4;
  word-break: break-word;
}

.pb-confirm-quality-btn {
  align-self: flex-start;
}

.pb-confirm-footer {
  background: #ffffff;
}
</style>

<style>
.pb-confirm-dialog {
  overflow: visible;
}

.pb-confirm-dialog > .v-card {
  background: #ffffff !important;
}
</style>
